<template>
  <div>
    <mdb-row>
      <mdb-col md="3">
        <subject-category @select-ncs-lecture="onSelectNcsLecture" @select-nonncs-subject="onNonncsSubject"/>
      </mdb-col>
      <mdb-col md="9" v-if="subject">
        <div class="sub-title mb-2">
          <mdb-icon  icon="highlighter" /> {{subject}}
          <span v-if="lecture">/ {{lecture}}</span>
        </div>
        <staff-test-summary-per-subject/>
      </mdb-col>
    </mdb-row>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import StudentList from '../../../components/common/StudentList.vue';
import SubjectCategory from '../../../components/subject/SubjectCategory.vue';
import StaffTestSummaryPerSubject from '../../../components/summary/StaffTestSummaryPerSubject.vue';
// import StaffTestBySubject from './StaffTestBySubject.vue'
export default {
  name: 'StaffTestSummaryByStudent',
  // components: { SubjectCategory, StaffTestBySubject },
  components: { SubjectCategory, StaffTestSummaryPerSubject },
  props: [],
  data: () => ({
    initStudent: '',
    student: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['isStaff']),
    ...mapState('training', ['training', 'subjects']),
    subject () {
      return this.$route.query.subject
    },
    lecture () {
      return this.$route.query.lecture
    }
  },
  methods: {
    async load () {
      // 초기화
    },
    onSelectNcsLecture (subject, lecture, code) {
      this.$router.replace({
        query: { subject, lecture, code }
      })
    },
    onNonncsSubject (subject) {
      this.$router.replace({
        query: { subject }
      })
    }
  },
  watch: {
    training () { }
  },
  created () { this.load() }
}
</script>
